// StoragePhoto.jsx — fetch & cache a signed URL for a Supabase Storage path.
import { useEffect, useState } from "react";
import { getPhotoUrl } from "../lib/supabase";

const cache = new Map(); // path -> { url, exp }

export function useStoragePhoto(path) {
  const [url, setUrl] = useState(() => {
    if (!path) return null;
    const c = cache.get(path);
    if (c && c.exp > Date.now()) return c.url;
    return null;
  });

  useEffect(() => {
    if (!path) { setUrl(null); return; }
    const c = cache.get(path);
    if (c && c.exp > Date.now()) { setUrl(c.url); return; }
    let cancelled = false;
    (async () => {
      const expSec = 3600;
      const u = await getPhotoUrl(path, expSec);
      if (cancelled || !u) return;
      cache.set(path, { url: u, exp: Date.now() + (expSec - 60) * 1000 });
      setUrl(u);
    })();
    return () => { cancelled = true; };
  }, [path]);

  return url;
}

export function StoragePhoto({ path, fallback = null, className = "", alt = "" }) {
  const url = useStoragePhoto(path);
  if (!url) return fallback;
  return <img src={url} alt={alt} className={className} />;
}
